import Component from '../component/component';

import './product-card.scss';
export default class ProductCard extends Component {
    static initSelector: string = '.product-card';

    constructor(target: HTMLElement) {
        super(target);

        this.init();
    }

    init(): void {
        const ro: ResizeObserver = new ResizeObserver(
            (entries: ResizeObserverEntry[]) => {
                const entry: ResizeObserverEntry = entries[0];
                const cr: DOMRectReadOnly = entry.contentRect;

                if (cr.width < 250) {
                    if (
                        !entry.target.classList.contains('product-card--narrow')
                    ) {
                        entry.target.classList.add('product-card--narrow');
                    }
                } else {
                    if (
                        entry.target.classList.contains('product-card--narrow')
                    ) {
                        entry.target.classList.remove('product-card--narrow');
                    }
                }
            },
        );

        ro.observe(this.element);
    }
}
